import React, { useState, useRef, useEffect } from 'react';
import { FiPlus, FiStar, FiMic, FiMusic } from 'react-icons/fi';

export default function AddItemButton({ onAdd }) {
    const [open, setOpen] = useState(false);
    const ref = useRef();

    useEffect(() => {
        const handler = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
        document.addEventListener('mousedown', handler);
        return () => document.removeEventListener('mousedown', handler);
    }, []);

    const choose = (type) => { setOpen(false); onAdd(type); };

    const btnStyle = {
        display:'flex', alignItems:'center', gap:8, background:'none',
        border:'1px dashed #c0c0d8', borderRadius:9, padding:'10px 16px', width:'100%',
        color:'#6b6b8a', fontSize:13, cursor:'pointer', transition:'border-color 0.15s',
        justifyContent:'center',
    };
    const menuStyle = {
        position:'absolute', bottom:'calc(100% + 6px)', left:0, right:0,
        background:'#fff', border:'1px solid #e0e0ec', borderRadius:10,
        boxShadow:'0 4px 20px rgba(0,0,0,0.12)', overflow:'hidden', zIndex:50,
    };
    const itemStyle = {
        display:'flex', alignItems:'center', gap:10, padding:'12px 16px',
        cursor:'pointer', fontSize:13, color:'#3f3f55', transition:'background 0.1s',
    };

    return (
        <div ref={ref} style={{ position:'relative', marginTop:8 }}>
            {open && (
                <div style={menuStyle}>
                    {[
                        { type:'intermission', icon:<FiStar size={14}/>, label:'Intermission' },
                        { type:'custom',       icon:<FiMic size={14}/>,  label:'Custom moment (speaker, announcement…)' },
                        { type:'unlisted',     icon:<FiMusic size={14}/>,label:'New routine (opening number, finale)' },
                    ].map(o => (
                        <div key={o.type} style={itemStyle}
                            onMouseEnter={e => e.currentTarget.style.background='#f2f3f9'}
                            onMouseLeave={e => e.currentTarget.style.background='transparent'}
                            onClick={() => choose(o.type)}>
                            <span style={{ color:'#29b8e5' }}>{o.icon}</span>
                            {o.label}
                        </div>
                    ))}
                </div>
            )}
            <button
                style={btnStyle}
                onMouseEnter={e => e.currentTarget.style.borderColor='#29b8e5'}
                onMouseLeave={e => e.currentTarget.style.borderColor='#c0c0d8'}
                onClick={() => setOpen(o => !o)}
            >
                <FiPlus size={15}/> Add intermission, custom item or routine
            </button>
        </div>
    );
}
